import React from 'react';
import { UseFormRegister } from 'react-hook-form';
import { useIntl } from 'react-intl';

import type { TFormFieldsMailSubscription } from '@/shared/api/mailSubscription/types';
import { ErrorMessage } from '@/shared/components/ErrorMessage';
import { TError } from '@/shared/components/ErrorMessage/types';
import type { TRoles } from '@/shared/types/mailSubscription';

import { Required } from '../Input/parts';
import {
  FieldsetRadioGroup,
  InputHide,
  LabelHide,
  RadioGroup,
  RadioInput,
  RadioLabel,
  RadioTitle,
  Title,
  Wrapper,
} from './parts';

interface IProps {
  roles: TRoles;
  register: UseFormRegister<TFormFieldsMailSubscription>;
  error?: TError;
}
const Roles: React.FC<IProps> = ({ roles, register, error }) => {
  const { formatMessage } = useIntl();

  const rolesTitle = formatMessage({ id: 'RolesTitle' });

  const list = roles.map((role) => {
    return (
      <RadioLabel key={role.Id.Guid} className="RadioLabel">
        <RadioInput
          {...register('Role')}
          className="RadioInput"
          type="radio"
          value={role.Name}
          id={`${role.Id.Guid}`}
        />
        <RadioTitle className="RadioTitle">{role.DisplayName}</RadioTitle>
      </RadioLabel>
    );
  });
  return (
    <Wrapper>
      <LabelHide htmlFor="Role_hide_field">Hidden Input</LabelHide>
      <InputHide
        {...(register &&
          register('Role', {
            required: {
              value: true,
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              message: {
                idIntl: 'IsRequiredMessage',
                values: {
                  0: rolesTitle,
                },
              },
            },
          }))}
        id="Role_hide_field"
        value=""
        type="radio"
        aria-hidden="true"
      />
      <FieldsetRadioGroup role="radiogroup">
        <Title>
          <span
            dangerouslySetInnerHTML={{
              __html: rolesTitle,
            }}
          />{' '}
          <Required />
        </Title>

        <RadioGroup role="group" aria-label={rolesTitle}>
          {list}
        </RadioGroup>
      </FieldsetRadioGroup>
      <ErrorMessage error={error} id="role-error" />
    </Wrapper>
  );
};

export default Roles;
